module.exports = __webpack_public_path__ + "img/hylp_icon.bc4b78bc.png";